import { RelayRequestAny, MiddlewareNextFn } from 'react-relay-network-modern';
//@ts-ignore
import { addQuery, getQuery } from '@mindtickle/utils/url';

import { isEmpty } from '../../../../utils';

export const appendQueryName = () => (next: MiddlewareNextFn) => (req: RelayRequestAny) => {
  try {
    const url = req.fetchOpts.url;
    if (url && 'id' in req && isEmpty(getQuery(url, ['name']))) {
      req.fetchOpts.url = addQuery(url, { name: req?.id });
    }
    return next(req);
  } catch (err) {
    console.error(err); // eslint-disable-line
    return next(req);
  }
};
